export default __webpack_public_path__ + "static/media/face4.9d91ec4c.jpg";